import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import axiosConn from '../../axiosConn';
import Topbar from '../../components/topbar/Topbar';
import useMobileView from '../../hooks/useMobileView';
import TopbarNotification from '../../components/topbarNotification/TopbarNotification';
import Sidebar from '../../components/sidebar/Sidebar';
import Rightbar from '../../components/rightbar/Rightbar';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { fetchIPData } from '../../utils/ipUtils';
import { getAirtimeAccessToken } from '../../utils/airtimeUtils';
import { AuthContext } from '../../context/AuthContext';
import { countryCodeToIso } from '../../utils/countryToIsoUtil';
import { useGetCurrPlayer } from '../../hooks/useGetCurrPlayer';
import ClipLoader from 'react-spinners/ClipLoader'; // Import the spinner component
import {
  usdJGKDecimalConversionRate,
  usdJGKConversionRate,
  jgkTransactionFee,
} from '../../utils/config';
import { useSuspension } from '../../context/SuspensionContext';
import { isSameDay } from '../../utils/dateUtil';
// import SendVerification from '../../components/sendVerification/SendVerification';

import './airtime.css';

const Airtime = () => {
  const { player } = useContext(AuthContext);
  const { isSuspended, setIsSuspended } = useSuspension();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const mobileView = useMobileView();
  const [visible, setVisible] = useState(0);
  const [operatorData, setOperatorData] = useState(null);
  const [ip, setIP] = useState('');
  const [countryName, setCountryName] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [accessToken, setAccessToken] = useState(null);
  const [showMin, setShowMin] = useState(0);
  const [showMax, setShowMax] = useState(0);
  const [jgkAmount, setJgkAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [airtimeTopupFee, setAirtimeTopupFee] = useState(0);
  const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState('');
  const [isLocal, setIsLocal] = useState(false);
  const [currPlayer, setCurrPlayer] = useState({});
  const [topupDate, setTopupDate] = useState(null); // State to store the top-up date
  const [disableSendButton, setDisableSendButton] = useState(false);

  // console.log(reloadlyAccessToken);
  const handlePhoneNumberChange = (value, country) => {
    // console.log('Country:', country);
    setPhoneNumber(value);
    const phoneNumberCountryCode = country.dialCode;
    const isoCode = countryCodeToIso[phoneNumberCountryCode] || '';
    setPhoneNumberCountryCode(isoCode);
    // console.log('Phone Number:', value);
    // console.log('Country ISO Code:', isoCode);
  };

  const onSuccess2 = (data) => {
    // console.log('data: ', data);
  };

  const onError2 = (err) => {
    // console.log('err: ', err);
  };

  const { data: data2, status: status2 } = useGetCurrPlayer(
    onSuccess2,
    onError2,
    player,
  );
  // console.log(data);

  useEffect(() => {
    let mounted = true;
    //set conversations
    if (status2 === 'success') {
      if (!mounted) return;
      setCurrPlayer(data2);
    }
    return () => {
      mounted = false;
    };
  }, [status2, data2]);

  useEffect(() => {
    let mounted = true;

    const fetchAccessToken = async () => {
      try {
        const token = await getAirtimeAccessToken();
        // console.log(token);
        if (mounted) {
          setAccessToken(token);
        }
      } catch (error) {
        console.error('Failed to fetch airtime access token:', error);
      }
    };

    fetchAccessToken();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    const getData = async () => {
      const data = await fetchIPData();
      if (data) {
        setIP(data.ip);
        setCountryName(data.country_name);
        setCountryCode(data.country_code);
        // console.log(data);
      }
    };
    getData();
  }, []);

  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    // console.log('Confirm button clicked');

    try {
      // Ensure required data is available
      if (!operatorData.operatorId || !amount || !phoneNumber) {
        throw new Error('Missing required fields');
      }

      const requestBody = {
        operatorId: operatorData.operatorId, // required
        amount: amount, // required
        useLocalAmount: isLocal, // default false
        customIdentifier: `https://www.joegalaxy.net ${
          player.data.player.playerId
        }-${phoneNumber}-${Date.now()}`,
        recipientPhone: {
          // required
          countryCode: phoneNumberCountryCode,
          number: phoneNumber,
        },
      };
      // console.log('Request Body:', requestBody);

      const response = await axiosConn.post(
        `/jgkTokenTransactions/jgkCashoutToAirTime`,
        {
          sender: player.data.player._id,
          jgkAmount: jgkAmount,
          requestBody: requestBody,
          reloadlyAirtimeTopUpAccessToken: accessToken.access_token,
        },
        {
          headers: {
            Authorization: `Bearer ${player.token}`,
          },
        },
      );

      // const response = await axios.post(url, requestBody, {
      //   headers: {
      //     Authorization: `Bearer ${accessToken.access_token}`,
      //     Accept: 'application/com.reloadly.topups-v1+json',
      //     'Content-Type': 'application/json',
      //   },
      // });

      // console.log('Response Data:', response.data.data);
      // Save the current date as the last top-up date
      if (topupDate) {
        localStorage.setItem(
          `lastTopupDate_${player.data.player._id}`,
          topupDate.toISOString(),
        );
      }
      setSuccess(
        `Top-up successful! Transaction ID: ${response.data.data.transactionId}`,
      );
      setLoading(false);
      setVisible(3);

      // Update the player's JGK tokens
      //api call to backend to update player's jgk tokens
    } catch (err) {
      console.error('Error:', err);
      setError(`Top-up failed. Please try again. ${err.message}`);
    } finally {
      setLoading(false);
      console.log('Loading state set to false');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (isSuspended) {
      setError('You are temporarily suspended from making transactions.');
      setLoading(false);
      return;
    }

    // Check if the player's profile photo is set
    if (
      player.data.player.profilePhoto ===
      'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
    ) {
      setError('Profile photo must be set before performing a top-up');
      setLoading(false);
      return;
    } else if (player.data.player.profilePhoto === '') {
      setError('Profile photo must be set before performing a top-up');
      setLoading(false);
      return;
    }

    // can't do this because email verify sometimes gets block
    // as spam.
    // Check if the player's account is verified
    // if (!player.data.player.verified) {
    //   setError('Verify your account before performing a top-up');
    //   setLoading(false);
    //   return;
    // }

    // Check if the player has already performed a top-up today
    const lastTopupDate = localStorage.getItem(
      `lastTopupDate_${player.data.player._id}`,
    );
    const now = new Date();
    setTopupDate(now);
    if (lastTopupDate && isSameDay(new Date(lastTopupDate), now)) {
      setError('You can only perform one top-up per day');
      setLoading(false);
      return;
    }

    try {
      if (!accessToken || !accessToken.access_token) {
        throw new Error('Access token is not available');
      }
      // console.log(accessToken.access_token);
      const countryIsoCode = phoneNumberCountryCode;
      // console.log('Access Token:', accessToken.access_token);
      // console.log('Country ISO Code:', countryIsoCode);
      // console.log('Phone Number:', phoneNumber);

      const url = `https://topups.reloadly.com/operators/auto-detect/phone/${phoneNumber}/countries/${countryIsoCode}`;
      // console.log('Request URL:', url);

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken.access_token}`,
          Accept: 'application/com.reloadly.topups-v1+json',
        },
      });

      // console.log('Response Data:', response.data);
      setOperatorData(response.data);
      //check if player is local to the country to set useLocalAmount to true
      // console.log(countryCode, response.data?.country.isoName);
      const isLocal =
        countryCode === response.data?.country.isoName ? true : false;
      if (isLocal && response.data?.supportsLocalAmounts === true) {
        setIsLocal(isLocal);

        //set useLocalAmount to true
        setShowMin(response.data?.minAmount * response.data?.fx.rate);
        setShowMax(response.data?.maxAmount * response.data?.fx.rate);
        setAirtimeTopupFee(response.data?.fees.local);
      } else {
        setShowMin(response.data?.minAmount);
        setShowMax(response.data?.maxAmount);
        setAirtimeTopupFee(response.data?.fees.international);
      }
      setAmount(response.data?.minAmount);
      setJgkAmount(
        response.data?.minAmount * usdJGKConversionRate +
          airtimeTopupFee * response.data?.fx.rate * usdJGKConversionRate,
      );
      // console.log(isLocal);
      const fee = isLocal
        ? response.data?.fees.localFee
        : response.data?.fees.international;
      console.log(fee);
      console.log(
        'JGK Amount:',
        response.data?.minAmount * usdJGKConversionRate +
          fee * response.data?.fx.rate * usdJGKConversionRate,
      );
      setSuccess('Top-up successful!');
      setVisible(1);
    } catch (err) {
      console.error('Error:', err);
      setError(`Top-up failed. Please try again. ${err.message}`);
    } finally {
      setLoading(false);
      console.log('Loading state set to false');
    }
  };

  const handleChange = (e) => {
    const newAmount = e.target.value === '' ? '' : parseFloat(e.target.value);
    setAmount(newAmount);

    if (newAmount === '') {
      setJgkAmount(0);
      return;
    }

    if (newAmount > 3) {
      setError('Amount should be less than or equal to $3');
      setDisableSendButton(true);
      return;
    }
    // Calculate the initial JGK amount
    let newJgkAmount =
      newAmount * usdJGKConversionRate +
      airtimeTopupFee * operatorData.fx.rate * usdJGKConversionRate;

    // Add an additional 3% fee
    // newJgkAmount = newJgkAmount + newJgkAmount * 0.03;

    setJgkAmount(newJgkAmount);
    console.log('Amount:', newAmount);
    console.log(
      'JGK Amount:',
      newJgkAmount,
      'Players JGK Tokens:',
      currPlayer?.jgkTokens,
    );

    // Set error if currPlayer.jgkTokens is less than jgkAmount
    if (currPlayer?.jgkTokens < newJgkAmount) {
      setError(`Insufficient JGK, send a lower amount.`);
    } else {
      setError('');
    }
  };

  return (
    <>
      {/* <Topbar /> */}
      {/* {mobileView && <TopbarNotification />} */}
      <div className="homeContainer">
        {!mobileView && <Sidebar />}
        <div className="feed">
          <div className="rld-card__wrapper">
            <section className="cardcontent">
              <div className="menu"></div>
              <div className="main-con">
                <div className="topup-container">
                  <h2>Mobile top-up</h2>
                  <p className="sub-heading">
                    Follow three easy steps to top-up in seconds. To do, please
                    set the receiver phone number below:
                  </p>
                  {visible === 0 && (
                    <form onSubmit={handleSubmit} className="is-12 w-100">
                      <div className="entry">
                        <label htmlFor="phone" className="label">
                          Add phone number
                        </label>
                        <PhoneInput
                          country={'us'}
                          value={phoneNumber}
                          onChange={handlePhoneNumberChange}
                          inputProps={{
                            name: 'phone',
                            required: true,
                            autoFocus: true,
                          }}
                          containerClass="phone-input-container"
                          inputClass="phone-input"
                          enableSearch
                        />
                        <button
                          type="submit"
                          className="loginButton"
                          disabled={loading}
                        >
                          {loading ? 'Processing...' : 'Next'}
                        </button>
                        {error && <div className="error_text">{error}</div>}
                        {success && (
                          <div className="success_text">{success}</div>
                        )}
                      </div>
                    </form>
                  )}
                  {visible === 1 && (
                    <form noValidate className="ng-untouched ng-valid ng-dirty">
                      <div className="phone-input ">
                        <input
                          type="tel"
                          autoComplete="off"
                          id="phone"
                          placeholder={phoneNumber}
                          maxLength="15"
                          validation="true"
                          className="input-container input-large ng-untouched ng-pristine"
                          disabled
                        />
                      </div>
                      <div className="operator-info">
                        <div className="operator-icon">
                          <img
                            className="operator-logo"
                            src={operatorData?.logoUrls?.[1]}
                          />
                        </div>
                        <div className="details">
                          <p className="detected-operater ng-star-inserted">
                            {' '}
                            We detected {operatorData?.name}{' '}
                          </p>
                          {/* <p className="not-operator ng-star-inserted">
                            {' '}
                            Not the operator? <span>Check operators</span>
                          </p> */}
                        </div>
                      </div>
                      <div className="fixed-amounts">
                        <div className="entry">
                          <label htmlFor="alt-ip" className="label">
                            Add amount{' '}
                          </label>
                          <div className="input-box w-100">
                            <input
                              size="large"
                              type="number"
                              id="alt-ip"
                              placeholder={`${showMin}`}
                              formcontrolname="amount"
                              className="input w-100 input-container input-large ng-untouched ng-pristine ng-valid"
                              min={showMin}
                              max={showMax}
                              value={amount}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <p className="note">
                          Amount between ${showMin} and ${showMax}
                        </p>
                      </div>
                      <div className="parent-container">
                        <div className="button-container">
                          <button
                            // reloadly-button
                            variant="filled"
                            color="secondary"
                            className="chatSubmitButton button-margin"
                            onClick={() => {
                              setVisible(0);
                              setError('');
                              setSuccess('');
                            }}
                          >
                            Back
                          </button>
                          <button
                            // reloadly-button
                            variant="filled"
                            color="primary"
                            className={
                              amount >= showMin &&
                              amount <= showMax &&
                              currPlayer?.jgkTokens >= jgkAmount &&
                              amount <= 3
                                ? 'airtimeSubmitButton button-margin'
                                : 'airtimeSubmitButtonDisabled button-margin'
                            }
                            onClick={() => setVisible(2)}
                            disabled={
                              amount < showMin ||
                              amount > showMax ||
                              loading ||
                              currPlayer?.jgkTokens < jgkAmount ||
                              amount > 3
                            }
                          >
                            Send
                          </button>
                        </div>
                      </div>
                      {error && (
                        <div className="error_text error_text_with_margin">
                          {error}
                        </div>
                      )}
                    </form>
                  )}
                  {visible === 2 && (
                    <div _ngcontent-ng-c228704162="" class="topup-container">
                      <h2 _ngcontent-ng-c228704162=""> Confirmation </h2>
                      <p
                        _ngcontent-ng-c228704162=""
                        class="description text-center"
                      >
                        You are about to send airtime to:{' '}
                        <span _ngcontent-ng-c228704162="" class="amount">
                          {phoneNumber}
                        </span>
                      </p>
                      <p _ngcontent-ng-c228704162="" class="description">
                        Amount:{' '}
                        <span _ngcontent-ng-c228704162="" class="amount">
                          {' '}
                          ${amount}{' '}
                        </span>
                      </p>
                      <p _ngcontent-ng-c228704162="" class="description">
                        Delivery Amount:{' '}
                        <span _ngcontent-ng-c228704162="" class="amount">
                          {' '}
                          {operatorData?.fx.currencyCode}{' '}
                          {operatorData?.fx.rate * amount}{' '}
                        </span>
                      </p>
                      <div _ngcontent-ng-c228704162="" class="operator-icon">
                        <img
                          src={operatorData?.logoUrls?.[1]}
                          alt={operatorData?.name}
                          className="operator-logo"
                        />
                      </div>
                      <div className="button-container">
                        <button
                          // reloadly-button
                          variant="filled"
                          color="secondary"
                          className="chatSubmitButton button-margin"
                          onClick={() => setVisible(1)}
                        >
                          Back
                        </button>
                        <button
                          // reloadly-button
                          variant="filled"
                          color="primary"
                          className={
                            amount >= showMin &&
                            amount <= showMax &&
                            currPlayer?.jgkTokens >= jgkAmount
                              ? 'airtimeSubmitButton button-margin'
                              : 'airtimeSubmitButtonDisabled button-margin'
                          }
                          onClick={handleSend}
                          disabled={
                            amount < showMin ||
                            amount > showMax ||
                            loading ||
                            currPlayer?.jgkTokens < jgkAmount
                          }
                        >
                          {loading ? (
                            <ClipLoader
                              size={20}
                              color="#ffffff"
                              loading={loading}
                            />
                          ) : (
                            'Confirm'
                          )}{' '}
                        </button>
                      </div>
                    </div>
                  )}
                  {visible === 3 && (
                    <div _ngcontent-ng-c2384574725="" class="topup-container">
                      <h2 _ngcontent-ng-c2384574725=""> Thank you! </h2>
                      <p _ngcontent-ng-c2384574725="" class="description">
                        You sent $ {amount} to
                      </p>
                      <p _ngcontent-ng-c2384574725="" class="description">
                        {phoneNumber}
                      </p>
                      <div className="button-container">
                        <button
                          // reloadly-button
                          variant="filled"
                          color="secondary"
                          className="chatSubmitButton button-margin"
                          onClick={() => {
                            setVisible(0);
                            setError('');
                            setSuccess('');
                          }}
                        >
                          Back
                        </button>
                      </div>
                      {success && <div className="success_text">{success}</div>}
                    </div>
                  )}
                  {/* {player.data.player.verified === false && (
                    <SendVerification player={player.data.player} />
                  )} */}
                </div>
              </div>
            </section>
          </div>
        </div>
        {!mobileView && <Rightbar />}
      </div>
    </>
  );
};

export default Airtime;
